import { BackendService } from './backend.service';
import { Injectable } from '@angular/core';
import { ALL_CDRS_BY_USER } from './gql_queries/cdrs.service.gql';

export interface CdrData {
  "__typename"?: string,
  id: string,
  period: string,
  cdrTimestamp: string,
  product: string,
  final: boolean,
  iccid: string,
  msisdn: string,
  cardName?: string
  imei?: string,
  service?: string,
  originNumber?: string,
  originCountry?: string,
  originIpAddress?: string,
  originRegion?: string,
  originState?: string,
  destNumber?: string,
  destNetwork?: string,
  destCountry?: string,
  destState?: string,
  volumeData?: string,
  volumeMin?: number,
  volumeMsg?: number,
  volumeInBundle?: string,
  volumeOutBundle?: string,
  volumeTotalData?: string,
  volumeTotalMsg?: number,
  volumeTotalMin?: number,
  usedMoney?: number,
  usedData?: string,
  usedMin?: number,
  usedMsg?: number,
  cdrCurrency?: string,
  cdrTotal?: number,
  cdrInBundle?: number,
  cdrInvoiced?: number,
}

interface CdrsByUserResponseFromServer {
  error?: string,
  data?: {
    cdrsByUser: CdrData[]
  }
}

@Injectable({
  providedIn: 'root'
})
export class CdrsService {
  constructor(
    private readonly backendService: BackendService
  ) {
  }

  async getAllCdrsByUser(userId: string): Promise<CdrData[]> {
    const result = await this.backendService.executeGraphQL(
      ALL_CDRS_BY_USER,
      {
        userId
      }
    ) as CdrsByUserResponseFromServer;

    if (result.data != null && result.data.cdrsByUser != null) {
      return result.data.cdrsByUser;
    } else {
      console.warn('No cdrs found for user:', userId);
    }
    return [];
  }


}
